<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      class="wizard-vertical mb-3"
      :start-index="startIndex"
    >
      <!-- profile tab -->
      <tab-content
        title="Informasi"
      >
        <RolesInfoForm
          ref="InformationForm"
          :form="form"
          :is-edit="isEdit"
        />
      </tab-content>

      <!-- alamat tab -->
      <tab-content
        title="Permissions"
      >
        <RolesPermissionsForm
          ref="PermissionsForm"
          :form="form"
          :is-edit="isEdit"
        />
      </tab-content>

      <template
        slot="footer"
        slot-scope="props"
      >
        <div class="wizard-footer-left">
          <wizard-button
            v-if="props.activeTabIndex > 0"
            :style="props.fillButtonStyle"
            @click.native="props.prevTab()"
          >
            Kembali
          </wizard-button>
        </div>
        <div class="wizard-footer-right">
          <wizard-button
            v-if="!props.isLastStep"
            class="wizard-footer-right"
            :style="props.fillButtonStyle"
            :disabled="isSubmitting"
            @click.native="validateInfo"
          >
            <b-spinner
              v-if="isSubmitting"
              small
            />
            {{ props.activeTabIndex === 0 ? 'Selanjutnya' : 'Simpan' }}
          </wizard-button>
        </div>
      </template>
    </form-wizard>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import {
// BButton,
  BSpinner,
} from 'bootstrap-vue'

import RolesPermissionsForm from '@/layouts/components/form/RolesPermissionsForm.vue'
import RolesInfoForm from '@/layouts/components/form/RolesInfoForm.vue'

// form wizard
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Ripple from 'vue-ripple-directive'

export default {
  components: {
    // BButton,
    BSpinner,

    // form
    RolesPermissionsForm,
    RolesInfoForm,

    // vue form wizard
    FormWizard,
    TabContent,
    WizardButton,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: '',
        permissions: [],
      },
      isPending: false,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState('roles', ['role']),
    roleId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
    startIndex() {
      // eslint-disable-next-line radix
      if (this.$route.query.start) return parseInt(this.$route.query.start)
      return 0
    },
  },
  async created() {
    this.isPending = true

    if (this.isEdit) {
      await this.getRole({ id: this.roleId })
      this.fillData()
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('roles', [
      'createRole',
      'updateRole',
      'getRole',
    ]),
    // validate section
    validateInfo() {
      this.isSubmitting = true
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const data = this.$refs.InformationForm.validationForm()
          data.then(success => {
            if (success) {
              resolve(true)
              this.handleSubmitInfo()
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(true)
            }
            this.isSubmitting = false
          })
        }, 1000)
      })
    },
    validatePermissions() {
      this.isSubmitting = true
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const data = this.$refs.PermissionsForm.validationForm()
          data.then(success => {
            if (success) {
              resolve(true)
              this.handleSubmitInfo()
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(true)
            }
            this.isSubmitting = false
          })
        }, 1000)
      })
    },
    // submit section
    async handleSubmitInfo() {
      this.isSubmitting = true

      if (!this.isEdit) {
        const info = await this.createRole(this.form)
        const idRole = info.data.id
        this.$router.push(`/roles/${idRole}/edit?start=1`)
      } else {
        await this.updateRole({ data: this.form, roleId: this.roleId })
      }

      this.isSubmitting = false
    },
    async handleSubmitPermission() {
      this.isSubmitting = true

      if (!this.isEdit) {
        const info = await this.createRole(this.form)
        const idRole = info.data.id
        this.$router.push(`/roles/${idRole}/edit?start=1`)
      } else {
        await this.updateRole({ data: this.form, roleId: this.roleId })
      }

      this.isSubmitting = false
    },
    // Edit State Only
    fillData() {
      this.form = this.role
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
</style>

<style lang="scss">
.image-preview {
    width: 102px;
    height: 102px;
    background-color: white;
    border: 1px solid red;
    position: relative;
    img {
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>
